import { FixedDistributionAccount, } from '@debbie/common/dist/economy/fixed-distributions/index.js';
// Automatic distributions are where the economy placed a joint payment; it
// moves them as the economy changes.
export const fixedDistributionLabel = (lang, fd) => {
    if (fd.derived) {
        return lang.economy.voucherInfoDistributionAutomatic;
    }
    return fd.account === FixedDistributionAccount.Creditor
        ? lang.economy.voucherInfoDistributionBilling
        : lang.economy.voucherInfoDistributionFixed;
};
//# sourceMappingURL=fixed-distribution-label.js.map